import React, {useState} from "react";
import BtnPrimary from "../boiteAOutils/BtnPrimary";
import {useStores} from "../stores/Context";
import ModalPrimary from "../boiteAOutils/ModalPrimary";

const ContactForm = () => {
    const {widgetStore} = useStores();
    const [message, setMessage] = useState(""); // État pour stocker le message de l'utilisateur
    const [type, setType] = useState("improvement");
    const [showModalPrimary, setShowModalPrimary] = useState(false);
    const [messageModal, setMessageModal] = useState("");

    const handleSubmit = async () => {
        if (message.trim() === "") {
            alert("Veuillez saisir un message.");
            return;
        }

        try {
            const email = JSON.parse(widgetStore.getCookie("currentUserInfos")).email;
            const response = await fetch(process.env.REACT_APP_API_URL + "/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({type, message, email}),
            });

            if (response.ok) {
                setShowModalPrimary(true);
                setMessageModal("Message envoyé avec succès !");
                setMessage(""); // Réinitialise le champ
                setType("improvement"); // Réinitialise le type
            } else {
                setShowModalPrimary(true);
                setMessageModal("Une erreur s'est produite lors de l'envoi du message.");
            }
        } catch (error) {
            console.error("Erreur :", error);
            setShowModalPrimary(true);
            setMessageModal("Une erreur s'est produite lors de l'envoi du message.");
        }
    };


    return (
        <>
            <div className="description">
                {/* Sélecteur pour le type */}
                <select className={"custom-select"}
                        value={type}
                        onChange={(e) => setType(e.target.value)} // Met à jour l'état `type`
                >
                    <option value="bug">Signaler un bug</option>
                    <option value="improvement">Demander une amélioration</option>
                </select>

                {/* Zone de texte pour le message */}
                <textarea placeholder="Votre message"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)} // Met à jour l'état `message`
                ></textarea>

                {/* Bouton pour soumettre */}
                <div>
                    <BtnPrimary onClick={handleSubmit}>
                        Valider
                    </BtnPrimary>
                </div>
            </div>

            {
                /*** Modal Primary ***/
                showModalPrimary ? (
                    <ModalPrimary
                        textTitle={""}
                        textComment={messageModal}
                        textBtnCancel={"Retour"}
                        onCancel={() => setShowModalPrimary(false)}
                    />
                ) : null
            }
        </>
    );
};

export default ContactForm;
